import { render, staticRenderFns } from "./labs.vue?vue&type=template&id=eef15cbe&scoped=true&"
import script from "./labs.vue?vue&type=script&lang=js&"
export * from "./labs.vue?vue&type=script&lang=js&"
import style0 from "./labs.vue?vue&type=style&index=0&id=eef15cbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eef15cbe",
  null
  
)

export default component.exports